import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook'
import { CompanyIcon } from '../../ui/icons/companyIcon'
import { LayoutComponent } from '../../ui/layout'
import { BillowButton } from '../../ui/molecules/billowButton'
import { Switch } from '../../ui/molecules/switch'
import { ConfirmModal } from '../../ui/organisms/confirmModal'
import { HorizontalTab } from '../../ui/organisms/horizontalTab'
import { MenuItems } from '../../ui/organisms/sidebar/dto'
import { Tab } from '../../ui/organisms/tab'
import { PurchaseHistory } from './payment/purchaseHistory'
import { createPaymentWithId, findAllPayments } from './payment/slice'
import { Registry } from './registry'
import { changeStatus, editCustomer, findCustomerById, setChangeStatusStatus, setTab } from './slice'

export function Operation() {
    const dispatch = useAppDispatch()

    const customerState = useAppSelector(state => state.customer)
    const paymentState = useAppSelector(state => state.payment)

    const [confirm, setConfirm] = useState(false)
    const [apply, setApply] = useState(false)

    useEffect(() => {
        const path = window.location.pathname
        dispatch(findCustomerById(path.split('/')[2]))
        dispatch(findAllPayments({ ...paymentState.findAllFilters, customerId: path.split('/')[2] }))
    }, [])

    useEffect(() => {
        if (customerState.changeStatusStatus === 'successfully') {
            const path = window.location.pathname
            dispatch(findCustomerById(path.split('/')[2]))
            dispatch(setChangeStatusStatus('idle'))
        }
    }, [customerState.changeStatusStatus])

    const customerMap = new Map<number, ReactElement>([[
        0, <PurchaseHistory />],
    [1, <Registry />]
    ])

    const customer = customerState.findCustomerByIdResponse
    const nameToShow = customer? customer.business_name.trim()? customer.business_name : (customer.name + " " + customer.surname) : ''

    return (
        <LayoutComponent menuItem={MenuItems.LISTING} headingLabel={nameToShow}
            headingButtons={customerState.tab === 0 ? [
                <div className=' flex gap-4'>
                    <Switch disabled={!customer|| !customer.vat.trim()} onChange={(value) => dispatch(changeStatus({ id: customer?.id ?? '', request: { active: value } }))} label='Pagamenti automatici' checked={customer?.active ?? false} />
                    <BillowButton disabled = {!customerState.findCustomerByIdResponse || !customerState.findCustomerByIdResponse.vat.trim() || !customerState.findCustomerByIdResponse.active} onClick={() => setConfirm(true)} label='Richiedi pagamento' iconPosition={'left'} variant={'solid'} />
                </div>
            ]
                :
                [<BillowButton onClick={() => {
                    setApply(true)
                }} disabled={!customerState.editCustomerRequest.name.trim() || !customerState.editCustomerRequest.surname.trim()} label='Applica' iconPosition={'left'} variant={'solid'} />]}
            breadcrumbItems={[('Clienti / ' + nameToShow)]}
            breadcrumbIcon={<CompanyIcon size={'20'} color={'#6237fb'} />}>
            <ConfirmModal open={confirm} handleClose={() => setConfirm(false)} title={"Richiedi pagamento"}
                description={"Vuoi davvero richiedere un pagamento?"} labelDeny={"No"} labelConfirm={"Si"} actionConfirm={
                    () => {
                        dispatch(createPaymentWithId(customerState.findCustomerByIdResponse!.id.toString()))
                        setConfirm(false)
                    }
                } />
            <ConfirmModal open={apply} handleClose={() => setApply(false)} title={"Applica modifiche"}
                description={"Vuoi davvero apportare queste modifiche?"} labelDeny={"No"} labelConfirm={"Si"} actionConfirm={
                    () => {
                        dispatch(editCustomer({
                            id: customerState.findCustomerByIdResponse!.id.toString(),
                            request: customerState.editCustomerRequest
                        }))
                        setApply(false)
                    }
                } />
            <HorizontalTab >
                <Tab selectedPrimary={customerState.tab === 0} label={'Storico Pagamenti'} onClick={() => dispatch(setTab(0))} type={'primary'} />
                <Tab selectedPrimary={customerState.tab === 1} label={'Anagrafica'} onClick={() => dispatch(setTab(1))} type={'primary'} />
            </HorizontalTab>
            {customerMap.get(customerState.tab)}
        </LayoutComponent>
    )
}
